import React, { useState, useEffect } from "react";
import {
    Box, TextField, Button, Typography, Divider, Card,
    Grid
} from "@mui/material";
import { db } from "../../firebase";
import { collection, getDocs, query, where, Timestamp, orderBy, onSnapshot } from "firebase/firestore";

function Purchasereport() {
    const today = new Date().toISOString().split("T")[0];
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [data, setData] = useState({ purchases: [], payments: [], products: [] });
    const [loading, setLoading] = useState(false);
    const [dealers, setdealers] = useState([]);
    const [payModes, setPayModes] = useState([]);


    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        const unsubdealers = onSnapshot(collection(db, "dealers"), snap => {
            setdealers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        const unsubPayModes = onSnapshot(collection(db, "payment_modes"), snap => {
            setPayModes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        return () => {
            unsubdealers();
            unsubPayModes();
        };

    };

    // Helper: Get Names from Props
    const getCustName = (id) => dealers.find(c => c.id === id)?.dealerName || id || "Unknown";
    const getPayModeName = (id) => payModes.find(m => m.id === id)?.payMode || "Cash";

    const fetchAllData = async () => {
        if (!fromDate || !toDate) return alert("Select date range");
        setLoading(true);

        try {
            const start = Timestamp.fromDate(new Date(fromDate + " 00:00:00"));
            const end = Timestamp.fromDate(new Date(toDate + " 23:59:59"));

            const qpurchases = query(collection(db, "purchases"), where("purchasedate", ">=", fromDate), where("purchasedate", "<=", toDate), orderBy("purchasedate", "desc"));
            const qPay = query(collection(db, "dealerPayments"), where("date", ">=", start), where("date", "<=", end), orderBy("date", "desc"));

            const [purchasesnap, paySnap] = await Promise.all([getDocs(qpurchases), getDocs(qPay)]);

            const dealerSnap = await getDocs(collection(db, "dealers"));

            const dealerMap = {};
            dealerSnap.forEach(doc => {
                dealerMap[doc.id] = doc.data().dealerName;
            });

            const purchases = purchasesnap.docs.map(doc => {
                const data = doc.data();

               const calculatedPurchaseTotal = Number(data.grandtotal || 0);

                return {
                    id: doc.id,
                    ...data,
                    displayDealer: dealerMap[data.dealerId] || "Unknown Dealer", // ✅ FIX
                    calculatedTotal: calculatedPurchaseTotal
                };
            });

            const payments = paySnap.docs.map(doc => {
                const pData = doc.data();

                return {
                    id: doc.id,
                    ...pData,
                    displayDealer: getCustName(pData.dealerId || pData.Dealer),
                    displayMode: getPayModeName(pData.paymentMode || pData.payMode)
                };
            });
            console.log(purchases);


            setData({ purchases, payments });
        } catch (err) {
            console.error("Fetch Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, [dealers, payModes]); // Re-run mapping if dependencies update

    // Stylings - Increased sizes slightly for clarity
    const cellStyle = { border: '1px solid #000', padding: '3px 6px', fontSize: '0.85rem', color: '#322626' };
    const headerStyle = { ...cellStyle, fontWeight: 'bold', backgroundColor: '#eeeeee', textAlign: 'center', fontSize: '0.9rem' };
    const nestedStyle = { ...cellStyle, border: 'none', fontSize: '0.75rem', padding: '2px 4px' };

    return (
        <Box p={1} sx={{ bgcolor: "#fff" }}>
            {/* Filters */}
            <Card sx={{ p: 2, mb: 3, display: 'flex', gap: 2, alignItems: 'center', borderRadius: '8px' }} className="no-print">
                <TextField size="small" label="From" type="date" InputLabelProps={{ shrink: true }} value={fromDate} onChange={e => setFromDate(e.target.value)} />
                <TextField size="small" label="To" type="date" InputLabelProps={{ shrink: true }} value={toDate} onChange={e => setToDate(e.target.value)} />
                <Button variant="contained" onClick={fetchAllData} disabled={loading} sx={{ minWidth: '120px' }}>{loading ? "Fetching..." : "Generate"}</Button>
                <Button variant="outlined" onClick={() => window.print()}>Print PDF</Button>
            </Card>

            <Grid className="printable-area p-2">
                <Box sx={{ border: '2px solid #000', p: 2 }}>
                    <Box textAlign="center" mb={2}>
                        <Typography variant="h5" fontWeight="bold">MATOSHRI INFRA DHARASHIV PVT LTD</Typography>
                        <Typography variant="body2">Sarola, Dist. Dharashiv, Maharashtra</Typography>
                        <Typography variant="subtitle2" sx={{ mt: 1, fontWeight: 'bold', letterSpacing: 1 }}>
                            MASTER PURCHASE REPORT ({fromDate} TO {toDate})
                        </Typography>
                        <Divider sx={{ my: 2, bgcolor: '#000', height: '2px' }} />
                    </Box>

                    {/* SECTION 1: purchases */}
                    <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold', mb: 1 }}>I. Purchase  LOG</Typography>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '5px' }}>
                        <thead>
                            <tr>
                                <th style={headerStyle}>Sr.</th>
                                <th style={headerStyle}>Date </th>
                                <th style={headerStyle}>Purchase No</th>
                                <th style={headerStyle}>Dealer </th>
                                <th style={headerStyle}>Purchase Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.purchases.map((row, index) => (
                                <tr key={row.id}>
                                    <td style={{ ...cellStyle, textAlign: 'center', width: '40px' }}>{index + 1}</td>
                                    <td style={{ ...cellStyle, width: '120px' }}>
                                        {row.purchasedate}
                                    </td>
                                    <td style={{ ...cellStyle, width: '120px' }}>
                                        <strong> {row.purchaseno}</strong>
                                    </td>
                                    <td style={cellStyle}>
                                        <strong>{row.displayDealer}</strong>
                                    </td>
                                    <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        ₹{(row.calculatedTotal ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                    </td>
                                </tr>
                            ))}
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                <td colSpan={4} style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold', fontSize: '1rem' }}>TOTAL Purchase AMOUNT</td>
                                <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold', fontSize: '1rem' }}>
                                    ₹{(data.purchases || []).reduce((s, i) => s + (i.calculatedTotal || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* SECTION 2: PAYMENTS */}
                    <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold', mb: 1 }}>II. Dealer COLLECTION HISTORY</Typography>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '5px' }}>
                        <thead>
                            <tr>
                                <th style={headerStyle}>Sr.</th>
                                <th style={headerStyle}>Payment Date</th>
                                <th style={headerStyle}>Dealer Name</th>
                                <th style={headerStyle}>Payment Mode</th>
                                <th style={headerStyle}>Paid Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.payments.map((row, index) => (
                                <tr key={row.id}>
                                    <td style={{ ...cellStyle, textAlign: 'center', width: '40px' }}>{index + 1}</td>
                                    <td style={{ ...cellStyle, textAlign: 'center' }}>{row.date?.toDate().toLocaleDateString()}</td>
                                    <td style={cellStyle}>{row.displayDealer}</td>
                                    <td style={{ ...cellStyle, textAlign: 'center' }}>{row.displayMode}</td>
                                    <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        ₹{(Number(row.amount) || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                    </td>
                                </tr>
                            ))}
                            <tr style={{ backgroundColor: '#f0f0f0' }}>
                                <td colSpan={4} style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold', fontSize: '1rem' }}>TOTAL COLLECTION</td>
                                <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold', fontSize: '1rem' }}>
                                    ₹{data.payments.reduce((s, i) => s + (Number(i.amount) || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </Box>
            </Grid>

            <style>{`
        @media print {
          body * { visibility: hidden; }
          .printable-area, .printable-area * { visibility: visible; }
          .printable-area { 
            position: absolute; 
            left: 0; 
            top: 0; 
            width: 100%; 
            border: none !important; 
          }
          .no-print { display: none !important; }
          @page { size: A4; margin: 10mm; }
        }
      `}</style>
        </Box>
    );
}

export default Purchasereport;